import React from "react";

export default function HomeSectionsBadge({
  label,
  className = "text-primaryBlue bg-[#DBEAFE80] mb-5",
}: {
  label: string;
  className?: string;
}) {
  return (
    <span
      className={`block w-full max-w-fit h-fit text-xs md:text-2xs font-semibold px-3 py-1 2md:py-2 rounded-full tracking-[1.2px] uppercase ${className}`}
    >
      {label}
    </span>
  );
}
